import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import { history } from 'kts-platform-frame/routes';
import language from 'kts-platform-frame/entry/Language';
import { IUserInfo } from 'kts-platform-frame/dataModel';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { Card, Tag, Modal } from 'antd';
import DescriptionList from 'ant-design-pro/lib/DescriptionList';
import { account3rdList, account3rdUnbind, oauth2WebBindOnly } from 'kts-platform-frame/api';
import message from 'kts-scaffold-framework/component/Message';
import JSString from 'kts-scaffold-framework/utils/kit/JSString';
import SwitchLanguage from 'kts-platform-frame/display/components/SwitchLanguage';
import UIVerificationPassword from './UI.VerificationPassword';
import UIChangePhone from './UI.ChangePhone';
import UIChangePhoneSuccess from './UI.ChangePhoneSuccess';
import ContactM from './UI.ContactM';

const { Description } = DescriptionList;
const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
    userInfo?: IUserInfo;
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

class UIInfoState {
    /** 是否绑定微信 */
    public isBinWx: boolean = false;
}

/** 绑定全局数据到props */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
    userInfo: state.user.userInfo,
}))
export default class UIInfo extends UIBasic<IProps, ModulesState, UIInfoState> {

    state = new UIInfoState();

    constructor(props: IProps) {
        super(props, ModulesAction);
    }

    /** 用户类型名称 */
    private get userTypeString(): string {
        const { userInfo } = this.props;
        const userTypeString: string = language.userTypeToString.get(userInfo.userType);
        return userTypeString || '未知';
    }
    /** 获取职位 */
    private get getJobs(): React.ReactElement {
        if (!Array.isArray(this.props.userInfo.groupNames)) {
            return ;
        }
        let jobs = this.props.userInfo.groupNames.map((item, index) => 
            <Tag key={index}>{item}</Tag>
            );
        return <div>{jobs}</div>;
    }

    componentDidMount() {
        this.upDateBinWx();
    }

    render() {
        const { userInfo } = this.props;
        const { stepChangePhone } = this.modulesState;
        // 账户信息
        const { phone, email, nickName } = this.modulesState.accountInfo;
        return (
            <div className={css.info}>
                <div className={css.titleType}>账户信息</div>
                <div className={css.infoContent}>
                    <DescriptionList title="" col={2} size="large" gutter={120}>
                        <Description term="姓名">
                            {nickName}
                        </Description>
                        <Description term="账号">
                            <div>{phone}</div>
                            <div>{email}</div>
                            {false && <a onClick={() => ModulesAction.openChangePhoneM(phone)}>修改手机号</a>}
                        </Description>
                        <Description term="密码">
                            <a href="javascript:;" onClick={this.handleChangePwd}>修改密码</a>
                        </Description>
                        <Description term="微信">
                            {
                                this.state.isBinWx
                                    ? <a href="javascript:;" onClick={this.onAccount3rdUnbindHandler}>解绑微信</a>
                                    : <a href="javascript:;" onClick={this.onAccount3rdbindHandler}>绑定微信</a>
                            }
                        </Description>
                    </DescriptionList>
                </div>

                <div className={css.titleType}>联系方式</div>
                <div className={css.infoContent}>
                    <DescriptionList title="" col={2} size="large" gutter={120}>
                        <Description term="手机号">
                            {userInfo.phone} &nbsp;&nbsp;
                            <a onClick={() => ModulesAction.changContactType('phone', userInfo.phone)}>修改</a>
                        </Description>
                        <Description term="邮箱">
                            {userInfo.email} &nbsp;&nbsp;
                            <a onClick={() => ModulesAction.changContactType('email', userInfo.phone)}>修改</a>
                        </Description>
                    </DescriptionList>
                </div>

                <div className={css.titleType}>身份信息</div>
                <div className={css.infoContent}>
                    <DescriptionList title="" col={2} size="large" gutter={120}>
                        <Description term="角色">
                            <Tag className={css.roleTag}>{this.userTypeString}</Tag>
                        </Description>
                        <Description term="职位">
                            {this.getJobs}
                        </Description>
                        <Description term="用户类型">
                            {userInfo.isInnerUser === '1' ? '内部员工': '外部员工'}
                        </Description>
                        <Description term="所属部门">
                            {userInfo.departmentName}
                        </Description>
                        <Description term="公开联系人">
                            {userInfo.isContactor ? '是' : '否'}
                        </Description>
                        <Description term="备注信息">
                            {userInfo.description}
                        </Description>
                        {/* <Description term="语言选择">
                        <SwitchLanguage />
                    </Description> */}
                    </DescriptionList>
                </div>
                {/* 修改联系方式(手机号/邮箱) */}
                {
                    this.modulesState.changContactVisibleM && <Modal
                        title={null}
                        centered={true}
                        width={'553px'}
                        footer={null}
                        visible={this.modulesState.changContactVisibleM}
                        bodyStyle={{
                            padding: 0
                        }}
                    >
                        <ContactM />
                    </Modal>
                }

                {/* 修改手机号 */}
                {
                    this.modulesState.visibleChangePhoneM && <Modal
                        title={null}
                        centered={true}
                        width={'553px'}
                        footer={null}
                        visible={this.modulesState.visibleChangePhoneM}
                        bodyStyle={{
                            padding: 0
                        }}
                    >
                        {stepChangePhone === 1 && <UIVerificationPassword />}
                        {stepChangePhone === 2 && <UIChangePhone />}
                        {stepChangePhone === 3 && <UIChangePhoneSuccess />}
                    </Modal>
                }
            </div>
        );
    }

    /** 更新 是否绑定了微信 */
    private upDateBinWx = async () => {
        const account3rdListData = await account3rdList(this);
        if (account3rdListData.er) {
            return;
        }

        if (account3rdListData.res && account3rdListData.res.length > 0) {
            this.setState({ isBinWx: true });
        } else {
            this.setState({ isBinWx: false });
            this.onAccount3rdbind();
        }
    }

    private handleChangePwd = (): void => {
        history.push("/workbench/platform/resetPwd");
    }

    private onAccount3rdbind = async () => {
        const code = JSString.getQueryString(window.location.search, 'code');
        const appId = 'wx02cd22ad009514f9';
        if (code) {
            const oauth2WebBindOnlyData = await oauth2WebBindOnly(this, { appId, code });
            if (oauth2WebBindOnlyData.er) {
                return;
            }
            message.success('绑定成功');
            this.setState({ isBinWx: true });
        }
    }

    /** 解除微信绑定 */
    private onAccount3rdUnbindHandler = async () => {
        const account3rdUnbindDate = await account3rdUnbind(this);
        if (account3rdUnbindDate.er) {
            return;
        }

        message.success('解除成功');
        this.setState({ isBinWx: false });
    }

    /** 微信绑定 */
    private onAccount3rdbindHandler = async () => {
        const appid = 'wx02cd22ad009514f9';
        const scope = 'snsapi_login';
        const redirect_uri = encodeURIComponent(`https://oauth2-wx.kingxunlian.com?redirect_url=${encodeURIComponent(window.location.origin + window.location.pathname)}`);
        window.location.href = `https://open.weixin.qq.com/connect/qrconnect?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=${scope}&state=3d6be0a4035d839573b04816624a415e#wechat_redirect`;
    }
}



// WEBPACK FOOTER //
// ./src/display/platform/UserCenter/UI.info.tsx